/**
 * Service worker registration, gated on the PWA build flag.
 *
 * process.env.PWA_ENABLED is injected by webpack's DefinePlugin and defaults
 * to FALSE in every config. Set PWA_ENABLED=true at build time to turn the
 * PWA back on.
 *
 * When disabled this does not simply do nothing: it actively unregisters any
 * worker already installed and drops the caches it created. A service worker
 * lives in the browser until something tells it to go away, so a returning
 * visitor would otherwise keep serving assets from the old worker's cache
 * indefinitely -- deleting sw.js from the build does NOT reach them.
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(
      window.location.hostname
    )
)

// DefinePlugin substitutes a literal, so this is decided at build time rather
// than read from the environment at runtime. (The registration branch is not
// necessarily stripped from the bundle -- babel-plugin-istanbul instruments
// every branch, which defeats dead-code elimination -- but it is unreachable.)
const pwaEnabled = process.env.PWA_ENABLED === true

const shouldRegister = () => {
  const isProd = process.env.NODE_ENV === 'production'
  const isSecureContext =
    window.location.protocol === 'https:' || isLocalhost === true
  return isProd && isSecureContext
}

/** Removes any previously installed worker and the caches it owned. */
const unregisterServiceWorker = () => {
  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      registrations.forEach(registration => registration.unregister())
    })
    .catch(() => {})

  // The registration going away does not evict what it cached, so the named
  // caches are removed too. Only ours -- anything else on the origin is left
  // alone.
  if (typeof caches !== 'undefined') {
    caches
      .keys()
      .then(keys => {
        keys
          .filter(key => key.startsWith('djcity-static-'))
          .forEach(key => caches.delete(key))
      })
      .catch(() => {})
  }
}

const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return
  }

  if (!pwaEnabled) {
    unregisterServiceWorker()
    return
  }

  if (!shouldRegister()) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

export default registerServiceWorker
